<template>
	<cTable ref="table" :fields="fields" :modals="modals" :header="header" :methods="methods" :config="config">
		<template #SHOWWAREHOUSE>
			<Card dis-hover style="margin-bottom: 20px">
				<p slot="title">
					{{ $t("packet") }}({{ list.awb && list.awb.length }})
					<Button type="primary" size="small" style="margin-left: 10px"
						@click="copy(list.awb)">{{ $t("copy") }}</Button>
				</p>
				<div class="cnb-div" style="height: 280px">
					<span style="margin-right: 5px; margin-bottom: 5px" class="cnb-num" v-for="item in list.awb"
						:key="item">{{ item }}</span>
				</div>
			</Card>
			<Card dis-hover>
				<p slot="title">
					{{ $t("ECommerce") }}({{ list.unpack && list.unpack.length }})
					<Button type="primary" size="small" style="margin-left: 10px"
						@click="copy(list.unpack)">{{ $t("copy") }}</Button>
				</p>
				<div class="cnb-div" style="height: 280px">
					<span style="margin-right: 5px; margin-bottom: 5px" class="cnb-num" v-for="item in list.unpack"
						:key="item">{{ item }}</span>
				</div>
			</Card>
		</template>
		<template #Apportion="{ visible, params }">
			<Apportion v-if="visible" :row="params" />
		</template>
		<template #cost="{ visible, params, close }">
			<CostPage :rows="params" :close="close" v-if="visible" />
		</template>
		<template #formBottom="{ visible, params, close }">
			<CusTomTable style="margin-bottom: 10px" :fields="data.fields" :config="data.config" :list="params.list">
			</CusTomTable>
		</template>

    <template #EMAILCONTENT>
      <Tabs v-model="tab" name="C">
        <TabPane v-for="tab in tabs" :label="tab.label" :name="tab.value" :key="tab.value" tab="C">
          <div v-if="tab.value === 'info'">
            <cForm :fields="info.fields" :grid="info.grid" :config="info.config" ref="info"></cForm>
          </div>
          <div v-else-if="tab.value === 'package'">
            <cTable :fields="packages.fields" :footer="{ show: () => false }" :config="packages.config"
                    ref="package"></cTable>
          </div>
          <div v-else-if="tab.value === 'email'">
            <cForm :fields="email.fields" :grid="email.grid" :config="email.config" ref="email">
              <template #editor="{params}">
                <editor ref="editor" plugins="advlist autolink link lists charmap wordcount table"
                        v-model="params.body"></editor>
              </template>
            </cForm>
          </div>
        </TabPane>
      </Tabs>
    </template>
	</cTable>
</template>

<script>
	import {
		getExtract,
		getPackages,
		del,
		getDetails,
		update,
		getPacking,
		getExportExcel,
		getExtractAnalyze,
		exportBatchExtract,
		exportThatDay,
		exportAirline,
		share,
		thirdParty,
		exportOrder,
		bayan,
		upload,
    info,
    read
	} from "@/api/extract/list";
	import {
		getConfig,
		getSubjectCost
	} from "@/api/tracker/cost_page";
	import {
		getTransportAgent,
		importCost
	} from "@/api/tracker/air";
	import {
		getAirport
	} from "@/api/system/airportList";
	import {
		getExtractConfig,
		getExtractNotWarehouse
	} from "@/api/extract/new";
	import cTable from "@/base/common/index";
	import expandRow from "./template/index";
	import Apportion from "./apportion";
	import {
		getSelectType,
		getKeysType
	} from "@/api/public";
	import copyClick from "@/utils/copyClick";
	import {
		getAgent
	} from "@/api/tracker/agent";
	import CostPage from "@/view/trackers/cost_page";
	import CusTomTable from "@/base/common/component/table";
	import {
		getUser
	} from "@/api/user/internal";
  import cForm from "@/base/common/component/form.vue";
  import editor from "_c/tiny-editor";

	export default {
		name: "extractList",
		components: {
      cForm,
			cTable,
			Apportion,
			CostPage,
			CusTomTable,
      editor
		},

		async mounted() {
			let list = (await getExtractConfig()).data.payload.list;
			let config = (await getConfig()).data.payload;
			let air_agent = (await getAgent({
				agent_type: "air"
			})).data.payload.rows;
			let baoguan_agent = (await getAgent()).data.payload.rows;
			let airportList = (await getAirport()).data.payload.rows;
			let HkList = (await getAgent({
				type: "HK"
			})).data.payload.rows;
			let transportAgentList = (await getTransportAgent()).data.payload;
			let creator = (await getUser()).data.payload.rows.map(t => {
				t.label = t.account + `(${t.realname})`;
				t.value = t.id;
				return t;
			});
			this.header.searchs.forEach(async item => {
				if (item.key === "fromStation") item.options = list.FromStation;
				if (item.key === "toStation") item.options = list.ToStation;
				if (item.key === "clearance_agent") item.options = list.ClearanceAgent;
				if (item.key === "creator_id") item.options = creator;
			});
			this.modals.update.fields.forEach(async item => {
				if (item.key === "from_station") item.options = list.FromStation;
				if (item.key === "to_station") item.options = list.ToStation;
				if (item.key === "air_agent") item.options = air_agent;
				if (item.key === "baoguan_agent") item.options = baoguan_agent;
				if (item.key === "hk_agent") item.options = HkList;
				if (item.key === "from_port") item.options = airportList;
				if (item.key === "to_port") item.options = airportList;
				if (item.key === "file_agent") item.options = transportAgentList;
			});
			this.modals.packingCostApportion.fields.forEach(async el => {
				if (el.key == "currency") el.options = config.currency;
				if (el.key == "agent_id") el.options = baoguan_agent;
			});
		},
		methods: {
			copy(data) {
				if (!data.length) return;
				copyClick.copyToClipboard(data.join("\r\n"), this);
			}
			// loadMethod(data) {
			//   let objAnalyze = {
			//     NCND: 0,
			//     NOR: 0,
			//     clearance_time: "0",
			//     exception_order: 0,
			//     flight_time: "0",
			//     ncnd_seven_pod_rate: "0",
			//     ncnd_ten_pod_rate: "0",
			//     ncnd_three_pod_rate: "0",
			//     nor_seven_pod_rate: "0",
			//     nor_ten_pod_rate: "0",
			//     nor_three_pod_rate: "0",
			//     not_arrival_warehouse: 0,
			//     order_total: 0,
			//     pod: 0,
			//     pod_rate: "0",
			//     refuse: 0,
			//     refuse_rate: "0",
			//     residence_time: "0",
			//     arrival_time: "0"
			//   };
			//   getExtractAnalyze(data.row.id).then(res => {
			//     // console.log(res);
			//     if (!res.data.status) {
			//       data.row["expand"] = objAnalyze;
			//       data.resolve();
			//       return;
			//     }
			//     data.row["expand"] = res.data.payload;
			//     data.resolve();
			//   });
			// }
		},
		data() {
			let dateTypeList = [{
						label: "depart_date",
						value: "depart_date"
					},
					{
						label: "arrival_HK_date",
						value: "arrival_HK_date"
					},
					{
						label: "arrival_date",
						value: "arrival_date"
					},
					{
						label: "clearance_date",
						value: "clearance_date"
					}
				],
				keywordsTypeList = [{
						title: this.$t("BillInformation"),
						value: "extract"
					},
					{
						title: this.$t("packing") + this.$t("alipay_name"),
						value: "packing"
					},
					{
						title: this.$t("bag") + this.$t("alipay_name"),
						value: "packages"
					},
					{
						title: this.$t("orderNum"),
						value: "airway_number"
					}
				],
				statusList = [{
						label: this.$t("Not") + this.$t("finish"),
						value: 0
					},
					{
						label: this.$t("finish"),
						value: 1
					}
				];
			return {
				data: {
					config: {
						height: 200
					},

          info: {
            config: {
              formBind: {
                labelWidth: 100
              },
              rowBind: {
                gutter: 16
              },
              colBind: {
                style: {
                  marginBottom: "20px"
                }
              }
            },
            fields: [{
              name: () => this.$tz("起运国"),
              key: "from_station",
              component: "Input",
              disabled: () => true,
              placeholder: () => " "
            },
              {
                name: () => this.$tz("目的国"),
                key: "to_station",
                component: "Input",
                disabled: () => true,
                placeholder: () => " "
              },
              {
                name: () => this.$tz("起运机场"),
                key: "from_airport",
                component: "Input",
                disabled: () => true,
                placeholder: () => " "
              },
              {
                name: () => this.$tz("目的机场"),
                key: "to_airport",
                component: "Input",
                disabled: () => true,
                placeholder: () => " "
              },
              {
                name: () => this.$tz("离港时间"),
                key: "depart_date",
                component: "Input",
                disabled: () => true,
                placeholder: () => " "
              },
              {
                name: () => this.$tz("到港时间"),
                key: "arrival_date",
                component: "Input",
                disabled: () => true,
                placeholder: () => " "
              },
              {
                name: () => this.$tz("清关代理"),
                key: "clearance_agent",
                component: "Input",
                disabled: () => true,
                placeholder: () => " "
              }
            ],
            grid: [{
              from_station: 12,
              from_airport: 12,
              to_station: 12,
              to_airport: 12,
              depart_date: 12,
              arrival_date: 12,
              clearance_agent: 12
            }]
          },

					fields: [{
							name: () => this.$t("data sources"),
							key: "source",

							tooltip: true,
							minWidth: 100
						},
						{
							name: () => this.$t("depart_date"),
							key: "depart_time",

							tooltip: true,
							minWidth: 100
						},
						{
							name: () => this.$t("toHKtime"),
							key: "arrival_time",
							tooltip: true,
							minWidth: 100
						}
					]
				},
				list: [],
				title: "",
				config: {
					rowId: "id",
					expandConfig: {
						accordion: true,
						lazy: true,
						loadMethod({
							row
						}) {
							let objAnalyze = {
								NCND: 0,
								NOR: 0,
								clearance_time: "0",
								exception_order: 0,
								flight_time: "0",
								ncnd_seven_pod_rate: "0",
								ncnd_ten_pod_rate: "0",
								ncnd_three_pod_rate: "0",
								nor_seven_pod_rate: "0",
								nor_ten_pod_rate: "0",
								nor_three_pod_rate: "0",
								not_arrival_warehouse: 0,
								order_total: 0,
								pod: 0,
								pod_rate: "0",
								refuse: 0,
								refuse_rate: "0",
								residence_time: "0",
								arrival_time: "0"
							};
							return new Promise(resolve => {
								getExtractAnalyze(row.id).then(res => {
									row["expand"] = res.data.status ? res.data.payload : objAnalyze;
									resolve(row);
								});
							});
						}
					}
				},
        email: {
          config: {
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16
            },
            colBind: {
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              mailBox: [{
                type: "array",
                required: true,
                message: "请输入,收件人,邮箱",
                trigger: "blur"
              }],
              subject: [{
                required: true,
                message: "请输入,邮件,标题",
                trigger: "blur"
              }],
              body: [{
                required: true,
                message: "请输入,邮件,内容",
                trigger: "blur"
              }]
            }
          },
          grid: [{
            mailBox: 24,
            subject: 24,
            attachment: 24,
            body: 24,
            save: 24
          }],
          fields: [{
            name: this.$tz("收件人,邮箱"),
            key: "mailBox",
            component: "Select",
            placeholder: () => this.$tz("收件人,邮箱"),
            options: [],
            bind: {
              filterable: true,
              multiple: true,
              "allow-create": true
            }
          },
            {
              name: () => this.$tz("邮件,标题"),
              key: "subject",
              component: "Input",
              placeholder: () => this.$tz("邮件,标题")
            },
            {
              name: () => this.$tz("邮件,内容"),
              key: "body",
              placeholder: () => this.$tz("邮件,内容"),
              solt: "editor"
            },
            {
              name: () => this.$tz("邮件,附件"),
              key: "attachment",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: true,
                isButton: true,
                type: "select"
              },
              default: [],
              methods: {
                fileClick({
                            row
                          }) {
                  this.openUrl(row.src);
                },
                beforeUpload({
                               file,
                               formData
                             }) {
                  console.log(this);
                  this.$page
                    .handleRequestMethods(
                      "upload", {
                        type: "clearance",
                        file,
                        id: this.$modal.params.info.id
                      },
                      true,
                      true
                    )
                    .then(res => {
                      formData["attachment"].push({
                        filename: file.name,
                        title: file.name,
                        url: this.$globalUrl + res.payload,
                        src: this.$globalUrl + res.payload
                      });
                    });
                  return false;
                }
              }
            },
            {
              name: () => "",
              key: "save",
              component: "Button",
              bind: {
                type: "primary"
              },
              methods: {
                render() {
                  return this.$tz("发送");
                },
                click: async () => {
                  let form = this.$refs["email"][0];
                  let modal = this.$refs["table"].getModal("email");
                  let formData = await form.submit();
                  formData.awbNumber = modal.params.mail.awbNumber;
                  delete formData.save;
                  console.log(arguments, formData);
                  this.$refs["table"]
                    .handleRequestMethods("send_mail", formData, true, true)
                    .then(res => {
                      this.$refs["table"].getModal("email").close();
                    });
                }
              }
            }
          ]
        },
        packages: {
          config: {
            slot: "div",
            resize: false,
            height: 600
          },
          fields: [{
            name: () => this.$tz("包裹,单号"),
            key: "packageNumber",
            minWidth: 110
          },
            {
              name: () => this.$tz("订单号"),
              key: "shipmentNumber",
              minWidth: 110
            }
          ]
        },
        info: {
          config: {
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16
            },
            colBind: {
              style: {
                marginBottom: "20px"
              }
            }
          },
          fields: [{
            name: () => this.$tz("起运国"),
            key: "from_station",
            component: "Input",
            disabled: () => true,
            placeholder: () => " "
          },
            {
              name: () => this.$tz("目的国"),
              key: "to_station",
              component: "Input",
              disabled: () => true,
              placeholder: () => " "
            },
            {
              name: () => this.$tz("起运机场"),
              key: "from_airport",
              component: "Input",
              disabled: () => true,
              placeholder: () => " "
            },
            {
              name: () => this.$tz("目的机场"),
              key: "to_airport",
              component: "Input",
              disabled: () => true,
              placeholder: () => " "
            },
            {
              name: () => this.$tz("离港时间"),
              key: "depart_date",
              component: "Input",
              disabled: () => true,
              placeholder: () => " "
            },
            {
              name: () => this.$tz("到港时间"),
              key: "arrival_date",
              component: "Input",
              disabled: () => true,
              placeholder: () => " "
            },
            {
              name: () => this.$tz("清关代理"),
              key: "clearance_agent",
              component: "Input",
              disabled: () => true,
              placeholder: () => " "
            }
          ],
          grid: [{
            from_station: 12,
            from_airport: 12,
            to_station: 12,
            to_airport: 12,
            depart_date: 12,
            arrival_date: 12,
            clearance_agent: 12
          }]
        },
        tab: "info",
        tabs: [{
          label: this.$tz("基本信息"),
          value: "info"
        },
          {
            label: this.$tz("包裹,信息"),
            value: "package"
          },
          {
            label: this.$tz("发送,邮件"),
            value: "email"
          }
        ],
				methods: {
					list: getExtract,
          info: info,
          read: read,
					getExtractNotWarehouse,
					exportThatDay,
					getDetails,
					getPackages,
					getExportExcel,
					del,
					update,
					getPacking,
					exportBatchExtract,
					getExtractAnalyze,
					exportAirline,
					importCost,
					share,
					thirdParty,
					exportOrder,
					bayan,
					upload
				},
				modals: {
					bayan: {
						config: {
							isNoPage: true,
							listFn: "bayan",
							title: this.$tz("bayan,文件"),
							modalBind: {
								width: 1000
							}
						},
						header: {
							show: () => true,
							btns: [{
								name: () => this.$tz("上传"),
								type: "upload",
								fnName: "upload",
								bind: {
									type: "primary"
								},
								id: 1870
							}],
							methods: {
								upload() {
									let el = document.createElement("input");
									el.type = "file";
									el.accept = "application/zip";
									el.click();
									el.addEventListener("input", e => {
										console.log(el.files[0], this.params);
										let formData = new FormData();
										formData.append("file", el.files[0]);
										upload(formData, this.params.id).then(res => {
											if (res.data.status) {
												this.$Message["success"]({
													background: true,
													content: res.data.msg
												});
												this.$page.getModal("bayan").getList();
											}
										});
									});
								}
							}
						},
						footer: {
							show: () => false
						},
						table: {
							config: {
								height: 600
							},
							fields: [{
									name: () => this.$tz("文件,名称"),
									key: "title",
									minWidth: 110
								},
								{
									name: () => this.$tz("操作人"),
									key: "create_name",
									minWidth: 110
								},
								{
									name: () => this.$tz("上传,时间"),
									key: "create_time",
									minWidth: 110
								},
								{
									name: () => this.$t("operation"),
									type: "btns",
									width: 220,
									fixed: "right",
									list: [{
										name: this.$tz("下载"),
										type: "down",
										fnName: "down",
										bind: {
											type: "primary"
										},
										id: ""
									}],
									methods: {
										down({
											row
										}) {
											window.open(row.src, "_blank");
										}
									}
								}
							]
						}
					},
					export: {
						type: "add",
						methods: {
							ok({
								row,
								close
							}) {
								let data = this.handleFilterData();
								this.$page
									.handleRequestMethods("exportOrder", data, true, true)
									.then(res => {
										window.open(this.$globalUrl + res.payload.src, "_blank");
									});
							}
						},
						config: {
							title: this.$tz("订单,导出"),
							modalBind: {
								width: 500
							},
							formBind: {
								labelWidth: 100
							},
							rowBind: {
								gutter: 16,
								style: {
									marginBottom: "20px"
								}
							},
							rules: {
								mawb: [{
									required: true,
									message: "cannot be empty",
									trigger: "blur"
								}]
							}
						},
						grid: [{
							mawb: 24
						}],
						fields: [{
							key: "mawb",
							name: () => this.$tz("提单号"),
							placeholder() {
								return this.$tz("提单号");
							},
							component: "Input",
							bind: {
								type: "textarea",
								autosize: {
									minRows: 4
								}
							}
						}]
					},
					uploadMsg: {
						config: {
							title: this.$t("updateFile") + this.$t("error_mes"),
							modalBind: {
								width: 500
							},
							rowBind: {
								gutter: 16,
								style: {
									marginBottom: "20px"
								}
							}
						},
						footer: {
							show: false
						},
						fields: [],
						table: {
							config: {
								height: 600
							},
							fields: [{
								name: () => this.$t("error_mes"),
								key: "msg",
								tooltip: true,
								minWidth: 100
							}]
						}
					},
					apportion: {
						contentSlot: "Apportion",
						config: {
							modalBind: {
								styles: {
									top: "50px"
								}
							},
							title: this.$t("apportion"),
							width: 80
						},
						footer: {
							show: () => false
						}
					},
					analysis: {
						methods: {
							ok({
								row,
								close
							}) {
								this.$page.handleRequestMethods("exportThatDay", row).then(e => {
									window.open(this.$globalUrl + e.payload);
									close();
								});
							}
						},
						footer: {
							ok: {},
							cancel: {}
						},
						config: {
							modalBind: {
								width: 400
							},
							formBind: {
								labelWidth: 100
							},
							rowBind: {
								gutter: 13,
								style: {
									marginBottom: "20px"
								}
							},
							rules: {
								time: [{
									required: true,
									type: "date",
									message: "analysis date cannot be empty",
									trigger: "change"
								}]
							}
						},
						grid: [{
							time: 24
						}],
						fields: [{
							name: () => this.$t("analysisDate"),
							key: "time",
							component: "DatePicker",
							placeholder() {
								return (
									this.$t("select") +
									this.$t("start") +
									this.$t("date") +
									this.$t("time")
								);
							},
							bind: {
								type: "date",
								options: {
									disabledDate(time) {
										return time.getTime() > Date.now();
									}
								}
							},
							methods: {
								format({
									searchForm,
									value,
									newFormData
								}) {
									return value ?
										this.format.dateFormat(value, "YYYY-MM-DD") :
										"";
								}
							}
						}]
					},
					packingCostApportion: {
						methods: {
							ok({
								row,
								close
							}) {
								this.$page.handleRequestMethods("share", row).then(e => {
									this.$page.getList();
									close();
								});
							}
						},
						footer: {
							ok: {},
							cancel: {}
						},
						config: {
							modalBind: {
								width: 600
							},
							formBind: {
								labelWidth: 100
							},
							rowBind: {
								gutter: 13,
								style: {
									marginBottom: "20px"
								}
							},
							rules: {
								packing: [{
									required: true,
									message: "cannot be empty",
									trigger: "change"
								}],
								expense_item: [{
									required: true,
									message: "cannot be empty",
									type: "array",
									trigger: "change"
								}],
								currency: [{
									required: true,
									message: "cannot be empty",
									trigger: "change"
								}],
								amount: [{
									required: true,
									message: "cannot be empty",
									trigger: "change"
								}],
								agent_id: [{
									required: true,
									message: "cannot be empty",
									trigger: "change",
									type: "number"
								}]
							}
						},
						grid: [{
								packing: 24
							},
							{
								expense_item: 24
							},
							{
								agent_id: 24
							},
							{
								currency: 24
							},
							{
								amount: 24
							},
							{
								remarks: 24
							}
						],
						fields: [{
								key: "packing",
								name: () => this.$t("packing_number"),
								component: "Input",
								bind: {
									type: "textarea"
								},
								placeholder() {
									return this.$t("enter") + this.$t("packing_number");
								}
							},
							{
								name: () => this.$t("expense"),
								key: "expense_item",
								minWidth: 120,
								component: "Cascader",
								placeholder() {
									return this.$t("select") + this.$t("expense");
								},
								options: [],
								default: [],
								methods: {
									async list({
										field
									}) {
										field.options = (
											await getSubjectCost({
												pid: 0
											})
										).data.payload;
									},
									async loadData({
										item,
										callback
									}) {
										item.loading = true;
										item.children = (
											await getSubjectCost({
												pid: item.value
											})
										).data.payload;
										item.loading = false;
										callback();
									}
								}
							},
							{
								name: () => this.$t("agentName"),
								key: "agent_id",
								component: "Select",
								placeholder() {
									return this.$t("select") + this.$t("agentName");
								},
								options: [],
								config: {
									label: "agent_name",
									value: "id"
								},
								disabled({
									row
								}) {
									return row.bill_id > 0;
								},
								methods: {
									render({
										field,
										value
									}) {
										return (
											(field.options.find(t => t.value === value) || {}).label ||
											"-"
										);
									}
								}
							},
							{
								name: () => this.$t("calculation") + this.$t("currency_t"),
								key: "currency",
								placeholder() {
									return (
										this.$t("select") +
										this.$t("calculation") +
										this.$t("currency_t")
									);
								},
								options: [],
								component: "Select",
								methods: {
									render({
										field,
										value
									}) {
										return (
											(field.options.find(t => t.value === value) || {}).label ||
											"-"
										);
									}
								}
							},
							{
								key: "amount",
								name: () => this.$t("cost_fee"),
								bind: {
									style: {
										width: "100%"
									}
								},
								component: "Input",
								placeholder() {
									return this.$t("enter") + this.$t("cost_fee");
								}
							},
							{
								key: "remarks",
								name: () => this.$t("Remarks"),
								component: "Input",
								bind: {
									type: "textarea"
								},
								placeholder() {
									return this.$t("enter") + this.$t("Remarks");
								}
							}
						]
					},
					showWarehouse: {
						contentSlot: "SHOWWAREHOUSE",
						config: {
							title: "not_arrival_warehouse",
							width: 1000
						},
						footer: {
							show: () => false,
							ok: {
								name: () => this.$t("copy")
							},
							cancel: {}
						},
						methods: {
							ok: () => {
								let data = this.list.join("\r\n");
								copyClick.copyToClipboard(data, this);
							}
						}
					},
					show: {
						config: {
							listFn: "list",
							modalBind: {
								width: 600
							},
							rowBind: {
								gutter: 16,
								style: {
									marginBottom: "20px"
								}
							}
						},
						footer: {
							show: false
						},
						fields: [],
						table: {
							config: {
								height: 600
							},
							fields: [{
									name: () => this.$t("order_number"),
									key: "airway_bill",
									copy: true,
									header: {
										copy: true //头部复制
									},
									tooltip: true,
									minWidth: 100
								},
								{
									name: () => this.$t("bagCode"),
									key: "package_number",

									tooltip: true,
									minWidth: 100
								}
							]
						}
					},
					number: {
						config: {
							title: this.$tz("明细"),
							modalBind: {
								width: 1000
							},
							listFn: "shipmentDetails"
						},
						footer: {
							show: () => false
						},
						table: {
							config: {
								height: 600
							},
							header: {
								searchs: [{
									key: "keywords",
									placeholder() {
										return this.$t("keyword");
									},
									component: "Input",
									bind: {
										type: "textarea",
										autosize: {
											minRows: 2,
											maxRows: 2
										}
									}
								}]
							},
							footer: {
								show: () => true
							},
							fields: [{
									name: () => this.$tz("袋子号"),
									key: "package_number",
									minWidth: 130
								},
								{
									name: () => this.$tz("订单号"),
									key: "airway_number",
									minWidth: 130
								},
								{
									name: () => this.$tz("入库重量"),
									key: "check_weight",
									minWidth: 130
								},
								{
									name: () => this.$tz("申报价值"),
									key: "values",
									minWidth: 130
								},
								{
									name: () => this.$tz("起运国"),
									key: "from_country",
									minWidth: 130
								},
								{
									name: () => this.$tz("目的国"),
									key: "to_country",
									minWidth: 130
								},
								{
									name: () => this.$tz("客户,原单号"),
									key: "client_refer_code",
									minWidth: 130
								}
							]
						}
					},
          email: {
            contentSlot: "EMAILCONTENT",
            footer: {
              show: () => false
            },
            config: {
              title: this.$tz("邮件"),
              modalBind: {
                width: 1000,
                styles: {
                  top: "10px"
                }
              }
            }
          },
					remarks: {
						config: {
							title: this.$tz("历史记录"),
							modalBind: {
								width: 1000
							}
						},
						footer: {
							show: () => false
						},
						table: {
							config: {
								height: 600
							},
							fields: [{
									name: () => this.$tz("信息"),
									key: "msg",
									minWidth: 110
								},
								{
									name: () => this.$tz("操作时间"),
									key: "ts",
									minWidth: 110
								}
							]
						}
					},
					update: {
						methods: {
							ok({
								row,
								close
							}) {
								this.$page.handleRequestMethods("update", row, true).then(e => {
									this.$page.getList();
									close();
								});
							}
						},
						footer: {
							ok: {},
							cancel: {}
						},
						slots: ["formBottom"],
						formBottom: "formBottom",
						config: {
							listFn: "list",
							modalBind: {
								width: "80%",
								styles: {
									top: "50px"
								}
							},
							formBind: {
								labelWidth: 150
							},
							rowBind: {
								gutter: 13
							},
							colBind: {
								style: {
									marginBottom: "20px"
								}
							},
							rules: {
								// carrier_code: [
								//   {
								//     required: true,
								//     type: "string",
								//     message: "carrier code cannot be empty",
								//     trigger: "blur"
								//   }
								// ],
								// clearance_agent: [
								//   {
								//     required: true,
								//     type: "string",
								//     message: "clearance agent cannot be empty",
								//     trigger: "blur"
								//   }
								// ],
								from_station: [{
									required: true,
									type: "string",
									message: "from Station cannot be empty",
									trigger: "change"
								}],
								to_station: [{
									required: true,
									type: "string",
									message: "to Station cannot be empty",
									trigger: "change"
								}],
								from_port: [{
									required: true,
									message: "from Station cannot be from_port",
									trigger: "change"
								}],
								to_port: [{
									required: true,
									message: "to Station cannot be to_port",
									trigger: "change"
								}],
								dept_date: [{
									required: true,
									type: "date",
									message: "to Station cannot be empty",
									trigger: "change"
								}],
								expected_date: [{
									required: true,
									type: "date",
									message: "to Station cannot be empty",
									trigger: "change"
								}],
								flight: [{
									required: true,
									type: "string",
									message: "to Station cannot be empty",
									trigger: "blur"
								}],
								load_type: [{
									required: true,
									type: "string",
									message: "to Station cannot be empty",
									trigger: "blur"
								}],
								mawb: [{
									required: true,
									type: "string",
									message: "to Station cannot be empty",
									trigger: "blur"
								}],
								quantity: [{
									required: true,
									type: "number",
									message: "to Station cannot be empty",
									trigger: "blur"
								}],
								shipping_mode: [{
									required: true,
									type: "string",
									message: "to Station cannot be empty",
									trigger: "blur"
								}],
								weight: [{
									required: true,
									type: "string",
									message: "to Station cannot be empty",
									trigger: "blur"
								}],
								number_of_shipment: [{
									required: true,
									type: "number",
									message: "to Station cannot be empty",
									trigger: "blur"
								}],
								hub: [{
									required: true,
									type: "string",
									message: "to Station cannot be empty",
									trigger: "blur"
								}]
							}
						},
						grid: [{
								carrier_code: 6,
								clearance_agent: 6,
								from_station: 6,
								to_station: 6,
								dept_date: 6,
								expected_date: 6,
								arrival_HK_date: 6,
								shipping_agent_date: 6,
								depart_date: 6,
								arrival_date: 6,
								clearance_start_date: 6,
								clearance_date: 6,
								flight: 6,
								load_type: 6,
								mawb: 6,
								quantity: 6,
								shipping_mode: 6,
								weight: 6,
								number_of_shipment: 6,
								hub: 6,
								//  charging_weight: 6, volume_weight: 6, air_agent: 6 ,
								volume_weight: 6,
								air_agent: 6,
								baoguan_agent: 6,
								from_port: 6,
								to_port: 6,
								extract_weight: 6,
								board_type: 6,
								hk_agent: 6,
								file_agent: 6,
								fastener: 6,
								remarks: 12
							}
							// { remarks: 24 }
						],
						fields: [{
								name: this.$tz("是否,整板,类型"),
								key: "board_type",
								component: "Select",
								placeholder: () => this.$tz("是否,整板,类型"),
								options: [],
								optionsFn: "boardType",
								optionsKey: "",
								default: ""
							},
							{
								key: "carrier_code",
								name: () => this.$t("carrier_code"),
								component: "Input",
								placeholder() {
									return this.$t("enter") + this.$t("carrier_code");
								},
								disabled: true
							},
							{
								key: "clearance_agent",
								name: () => this.$t("clearagent"),
								component: "Input",
								placeholder() {
									return this.$t("enter") + this.$t("clearagent");
								},
								disabled: true
							},
							{
								key: "air_agent",
								name: () => this.$t("air_agent"),
								component: "Select",
								config: {
									label: "agent_name",
									value: "agent_name"
								},
								options: [],
								placeholder() {
									return this.$t("select") + this.$t("air_agent");
								}
							},
							{
								key: "baoguan_agent",
								name: () => this.$t("warehousCustomsAgent"),
								component: "Select",
								config: {
									label: "agent_name",
									value: "agent_name"
								},
								options: [],
								placeholder() {
									return this.$t("select") + this.$t("warehousCustomsAgent");
								}
							},
							{
								key: "hk_agent",
								name: () => this.$t("HKagency"),
								component: "Select",
								config: {
									label: "agent_name",
									value: "agent_name"
								},
								options: [],
								placeholder() {
									return this.$t("select") + this.$t("HKagency");
								}
							},
							{
								key: "file_agent",
								name: () => this.$tz("文件,代理"),
								component: "Select",
								config: {
									value: "label"
								},
								options: [],
								placeholder() {
									return this.$tz("请选择,文件,代理");
								}
							},
							{
								key: "from_station",
								name: () => this.$t("from_station"),
								component: "Select",
								config: {
									label: "name",
									value: "key"
								},
								placeholder() {
									return this.$t("select") + this.$t("from_station");
								},
								options: []
							},
							{
								key: "to_station",
								name: () => this.$t("to_station"),
								component: "Select",
								config: {
									label: "name",
									value: "key"
								},
								placeholder() {
									return this.$t("select") + this.$t("to_station");
								},
								options: []
							},
							{
								key: "from_port",
								name: () => this.$t("departureAirport"),
								component: "Select",
								config: {
									label: "code",
									value: "code"
								},
								placeholder() {
									return this.$t("select") + this.$t("departureAirport");
								},
								options: [],
								disabled: ({
									row
								}) => {
									return !!row.from_port;
								}
							},
							{
								key: "to_port",
								name: () => this.$t("destinationAirport"),
								component: "Select",
								config: {
									label: "code",
									value: "code"
								},
								placeholder() {
									return this.$t("select") + this.$t("destinationAirport");
								},
								options: [],
								disabled: ({
									row
								}) => {
									return !!row.to_port;
								}
							},
							{
								key: "dept_date",
								name: () => this.$t("dept_date"),
								component: "DatePicker",
								disabledDate: true,
								bind: {
									type: "datetime"
								},
								disabledDate(time) {
									return false;
								},
								placeholder() {
									return this.$t("enter") + this.$t("dept_date");
								}
							},
							{
								key: "expected_date",
								name: () => this.$t("expected_date"),
								component: "DatePicker",
								disabledDate: true,
								bind: {
									type: "datetime"
								},
								disabledDate(time) {
									return false;
								},
								placeholder() {
									return this.$t("enter") + this.$t("expected_date");
								}
							},
							{
								key: "arrival_HK_date",
								name: () => this.$t("arrival_HK_date"),
								component: "DatePicker",
								disabledDate: true,
								bind: {
									type: "datetime"
								},
								data: ["shipping_agent_date"],
								placeholder() {
									return this.$t("enter") + this.$t("arrival_HK_date");
								},
								methods: {
									"on-close"({
										formData,
										field
									}) {
										let data = field.data;
										data.find(t => {
											let start = formData[t] ? formData[t].getTime() : 0;
											let end = formData[field.key] ?
												formData[field.key].getTime() :
												0;
											let time = 86400000 * 3;
											if (
												start &&
												(start < end ? end > start + time : end + time < start)
											) {
												this.$Modal.confirm({
													title: this.$t("tip"),
													width: 400,
													content: this.$t("differenceDay") +
														this.$page.format.timeFormat(formData[field
															.key])
												});
												return true;
											}
										});
									}
								}
							},
							{
								key: "shipping_agent_date",
								name: () => this.$t("Air Agency Time"),
								component: "DatePicker",
								disabledDate: true,
								bind: {
									type: "datetime"
								},
								data: ["arrival_HK_date", "depart_date"],
								placeholder() {
									return this.$t("enter") + this.$t("Air Agency Time");
								},
								methods: {
									"on-close"({
										formData,
										field
									}) {
										let data = field.data;
										data.find(t => {
											let start = formData[t] ? formData[t].getTime() : 0;
											let end = formData[field.key] ?
												formData[field.key].getTime() :
												0;
											let time = 86400000 * 3;
											if (
												start &&
												(start < end ? end > start + time : end + time < start)
											) {
												this.$Modal.confirm({
													title: this.$t("tip"),
													width: 400,
													content: this.$t("differenceDay") +
														this.$page.format.timeFormat(formData[field
															.key])
												});
												return true;
											}
										});
									}
								}
							},
							{
								key: "clearance_start_date",
								name: () => this.$t("Clearance Start Time"),
								component: "DatePicker",
								// disabledDate: true,
								bind: {
									type: "datetime"
								},
								data: ["arrival_date", "clearance_date"],
								placeholder() {
									return this.$t("enter") + this.$t("Clearance Start Time");
								},
								methods: {
									"on-close"({
										formData,
										field
									}) {
										let data = field.data;
										data.find(t => {
											let start = formData[t] ? formData[t].getTime() : 0;
											let end = formData[field.key] ?
												formData[field.key].getTime() :
												0;
											let time = 86400000 * 3;
											if (
												start &&
												(start < end ? end > start + time : end + time < start)
											) {
												this.$Modal.confirm({
													title: this.$t("tip"),
													width: 400,
													content: this.$t("differenceDay") +
														this.$page.format.timeFormat(formData[field
															.key])
												});
												return true;
											}
										});
									}
								}
							},
							{
								key: "depart_date",
								name: () => this.$t("depart_date"),
								component: "DatePicker",
								// disabledDate: true,
								bind: {
									type: "datetime"
									// arrival_HK_date: 7, shipping_agent_date:7, depart_date: 7, arrival_date: 7 ,
									// clearance_start_date:7,clearance_date: 7, flight: 7, load_type: 7,
								},
								data: ["shipping_agent_date", "arrival_date"],
								placeholder() {
									return this.$t("enter") + this.$t("depart_date");
								},
								methods: {
									"on-close"({
										formData,
										field
									}) {
										let data = field.data;
										data.find(t => {
											let start = formData[t] ? formData[t].getTime() : 0;
											let end = formData[field.key] ?
												formData[field.key].getTime() :
												0;
											let time = 86400000 * 3;
											if (
												start &&
												(start < end ? end > start + time : end + time < start)
											) {
												this.$Modal.confirm({
													title: this.$t("tip"),
													width: 400,
													content: this.$t("differenceDay") +
														this.$page.format.timeFormat(formData[field
															.key])
												});
												return true;
											}
										});
									}
								}
							},
							{
								key: "arrival_date",
								name: () => this.$t("arrival_date"),
								component: "DatePicker",
								// disabledDate: true,
								bind: {
									type: "datetime"
								},
								data: ["depart_date", "clearance_date"],
								placeholder() {
									return this.$t("enter") + this.$t("arrival_date");
								},
								methods: {
									"on-close"({
										formData,
										field
									}) {
										let data = field.data;
										data.find(t => {
											let start = formData[t] ? formData[t].getTime() : 0;
											let end = formData[field.key] ?
												formData[field.key].getTime() :
												0;
											let time = 86400000 * 3;
											if (
												start &&
												(start < end ? end > start + time : end + time < start)
											) {
												this.$Modal.confirm({
													title: this.$t("tip"),
													width: 400,
													content: this.$t("differenceDay") +
														this.$page.format.timeFormat(formData[field
															.key])
												});
												return true;
											}
										});
									}
								}
							},
							{
								key: "clearance_date",
								name: () => this.$t("clearance_done_date"),
								component: "DatePicker",
								// disabledDate: true,
								bind: {
									type: "datetime"
								},
								data: ["clearance_start_date"],
								placeholder() {
									return this.$t("enter") + this.$t("clearance_done_date");
								}
							},
							{
								key: "flight",
								name: () => this.$t("flight"),
								component: "Input",
								placeholder() {
									return this.$t("enter") + this.$t("flight");
								}
							},
							{
								key: "load_type",
								name: () => this.$t("load_type"),
								component: "Input",
								placeholder() {
									return this.$t("enter") + this.$t("load_type");
								},
								disabled: true
							},
							{
								key: "mawb",
								name: () => this.$t("mawb"),
								component: "Input",
								placeholder() {
									return this.$t("enter") + this.$t("mawb");
								}
							},
							{
								key: "quantity",
								name: () => this.$t("number_of_bags"),
								bind: {
									style: {
										width: "100%"
									}
								},
								component: "InputNumber",
								placeholder() {
									return this.$t("enter") + this.$t("number_of_bags");
								},
								disabled: true,
								default: 0
							},
							{
								key: "shipping_mode",
								name: () => this.$t("shipping_mode"),
								component: "Input",
								placeholder() {
									return this.$t("enter") + this.$t("shipping_mode");
								},
								disabled: true
							},
							{
								key: "weight",
								name: () => this.$t("Weight"),
								component: "Input",
								placeholder() {
									return this.$t("enter") + this.$t("Weight");
								}
							},
							// {
							//   key: "charging_weight",
							//   name: () => this.$t("charge_params"),
							//   component: "Input",
							//   placeholder() {
							//     return this.$t("enter") + this.$t("charge_params");
							//   }
							// },
							{
								key: "volume_weight",
								name: () => this.$t("charge_volume"),
								component: "Input",
								placeholder() {
									return this.$t("enter") + this.$t("charge_volume");
								}
							},
							{
								key: "extract_weight",
								name: () => this.$t("extract") + this.$t("Weight"),
								component: "Input",
								placeholder() {
									return (
										this.$t("enter") + this.$t("extract") + this.$t("Weight")
									);
								}
							},
							{
								key: "number_of_shipment",
								bind: {
									style: {
										width: "100%"
									}
								},
								name: () => this.$t("number_of_shipment"),
								component: "InputNumber",
								placeholder() {
									return this.$t("enter") + this.$t("number_of_shipment");
								},
								disabled: true,
								default: 0
							},
							{
								key: "hub",
								name: () => this.$t("hub"),
								component: "Input",
								placeholder() {
									return this.$t("enter") + this.$t("hub");
								},
								disabled: true
							},
							{
								key: "remarks",
								name: () => this.$t("Remarks"),
								component: "Input",
								bind: {
									type: "textarea"
								},
								placeholder() {
									return this.$t("enter") + this.$t("Remarks");
								}
							},
							{
								key: "fastener",
								name: () => this.$t("fastening"),
								component: "Input",
								bind: {
									type: "textarea"
								},
								placeholder() {
									return this.$t("enter") + this.$t("fastening");
								}
							}
						],
						table: {
							config: {
								height: 200
							},
							fields: [{
									name: () => this.$t("packing_number"),
									key: "packing_number",

									tooltip: true,
									minWidth: 100
								},
								{
									name: () => this.$t("number_of_shipment"),
									key: "airway_bill_total",

									tooltip: true,
									minWidth: 100
								},
								{
									name: () => this.$t("number_of_bags"),
									key: "package_number_total",

									tooltip: true,
									minWidth: 100
								}
							]
						}
					},
					openCost: {
						contentSlot: "cost",
						config: {
							modalBind: {
								styles: {
									top: "30px"
								},
								width: 90,
								draggable: true,
								sticky: true
							}
						},
						footer: {
							show: () => false
						}
					}
				},
				header: {
					searchs: [{
							key: "dateType",
							placeholder() {
								return this.$t("select") + this.$t("date") + this.$t("type");
							},
							component: "Select",
							config: {
								label({
									row
								}) {
									return this.$t(row.label);
								}
							},
							options: [],
							methods: {
								async list({
									field,
									searchForm
								}) {
									let res = await this.$sel.getData("OMS_MAWB_DATE_TYPE");
									field.options = res;
									searchForm[field.key] = res[0] && res[0].value;
									this.$forceUpdate();
								}
							}
						},
						{
							key: "startTime",
							component: "DatePicker",
							placeholder() {
								return (
									this.$t("select") +
									this.$t("start") +
									this.$t("date") +
									this.$t("time")
								);
							},
							bind: {
								type: "datetime",
								options: {
									disabledDate(time) {
										return time.getTime() > Date.now();
									}
								},
								style: {
									width: "175px"
								}
							},
							methods: {
								"on-change"({
									searchForm
								}) {
									searchForm.startTime = searchForm.startTime ?
										this.$page.format.timeFormat(searchForm.startTime) :
										"";
								}
								// format({ searchForm, value, newFormData }) {
								//   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
								// }
							}
						},
						{
							key: "endTime",
							component: "DatePicker",
							placeholder() {
								return this.$t("select") + this.$t("end") + this.$t("date");
							},
							bind: {
								type: "datetime",
								options: {
									disabledDate(time) {
										return time.getTime() > Date.now();
									}
								},
								style: {
									width: "175px"
								}
							},
							methods: {
								// format({ searchForm, value, newFormData }) {
								//   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
								// }
								"on-change"({
									searchForm
								}) {
									let time = this.$page.format.timeFormat(searchForm.endTime);
									if (time.slice(-8) === "00:00:00") {
										time = time.split(" ")[0] + " " + "23:59:59";
										searchForm.endTime = time;
									}
								}
							}
						},
						{
							key: "creator_id",
							placeholder() {
								return this.$tz("创建人");
							},
							component: "Select",
							options: [],
							optionsFn: "",
							optionsKey: ""
						},
						{
							key: "fromStation",
							placeholder() {
								return this.$t("select") + this.$t("from_station");
							},
							component: "Select",
							config: {
								label: "name",
								value: "key"
							},
							options: []
						},
						{
							key: "toStation",
							placeholder() {
								return this.$t("select") + this.$t("to_station");
							},
							component: "Select",
							config: {
								label: "name",
								value: "key"
							},
							options: []
						},
						{
							key: "tripStatus",
							placeholder() {
								return (
									this.$t("select") + this.$t("extract") + this.$t("TravelStatus")
								);
							},
							component: "Select",
							options: [],
							methods: {
								async list({
									field,
									searchForm
								}) {
									let res = (await getSelectType(["TRIP_STATUS_TYPE"])).data
										.payload["TRIP_STATUS_TYPE"];
									field.options = res;
									// searchForm[field.key] = res[0].value;
									this.$forceUpdate();
								}
							}
						},
						{
							name: this.$tz("目的机场"),
							key: "to_port",
							component: "Select",
							placeholder: () => this.$tz("目的机场"),
							options: [],
							optionsFn: "getAirPort",
							optionsKey: "",
							default: ""
						},
						{
							key: "status",
							placeholder() {
								return this.$t("select") + this.$t("finish") + this.$t("exlType");
							},
							component: "Select",
							config: {
								label({
									row
								}) {
									return this.$t(row.label);
								}
							},
							options: statusList
						},
						{
							key: "clearance_agent",
							placeholder() {
								return this.$t("select") + this.$t("clearagent");
							},
							component: "Select",
							config: {
								label: "name",
								value: "key"
							},
							options: []
						},
						{
							key: "costType",
							placeholder() {
								return this.$t("whether") + this.$t("costEntry");
							},
							component: "Select",
							config: {
								label({
									row
								}) {
									return this.$t(row.label);
								}
							},
							options: [{
									label: "YES",
									value: "YES"
								},
								{
									label: "NO",
									value: "NO"
								}
							]
						},
						{
							key: "tiktok",
							placeholder() {
								return this.$tz("是否,包含,TT,订单");
							},
							component: "Select",
							options: [{
									label: this.$tz("是"),
									value: "1"
								},
								{
									label: this.$tz("否"),
									value: "2"
								}
							],
							optionsFn: "",
							optionsKey: ""
						},
						{
							key: "temu",
							placeholder() {
								return this.$tz("是否,包含,TM,订单");
							},
							component: "Select",
							options: [{
									label: this.$tz("是"),
									value: "1"
								},
								{
									label: this.$tz("否"),
									value: "2"
								}
							],
							optionsFn: "",
							optionsKey: ""
						},
						{
							key: "keywordsType",
							placeholder() {
								return this.$t("select") + this.$t("keyword") + this.$t("type");
							},
							component: "Select",
							config: {
								label({
									row
								}) {
									return this.$t(row.label);
								}
							},
							options: [],
							methods: {
								async list({
									field,
									searchForm
								}) {
									let res = await this.$sel.getData("OMS_MAWB_KEYWORDS");
									field.options = res;
									searchForm[field.key] = res[0] && res[0].value;
									this.$forceUpdate();
								}
							}
						},
						{
							key: "keywords",
							placeholder() {
								return this.$t("keyword");
							},
							bind: {
								type: "textarea",
								rows: 1
							},
							component: "Input"
						}
					],
					btns: {
						list: [{
								name: () => this.$tz("导出"),
								type: "export",
								btnBind: {
									type: "primary"
								},
								list: [{
										name: () => this.$tz("列表数据"),
										type: "export",
										fnName: "exportFun",
										disabled(row) {
											return !this.selectAll.length;
										}
									},
									{
										name: () => this.$tz("分析"),
										type: "analysis",
										fnName: "analysisFun"
									},
									{
										name: () => this.$tz("航司信息"),
										type: "airlineMsg",
										fnName: "airlineMsgFun",
										disabled(row) {
											return !this.selectAll.length;
										}
									},
									{
										name: () => this.$tz("航班,信息"),
										type: "flight",
										fnName: "flight"
									},
									{
										name: () => this.$tz("订单"),
										type: "exportOrder",
										fnName: "exportOrder"
									}
								]
							},
							{
								name: () => this.$t("finalCost") + this.$t("template"),
								url: "/doc/zh-CN/cost.xlsx",
								fnName: "down",
								bind: {
									type: "primary",
									icon: "md-download"
								}
							},
							{
								name: () => this.$t("finalCost") + this.$t("import"),
								fnName: "updateFile",
								type: "importCost",
								component: "Upload",
								bind: {
									showUploadList: false,
									icon: "ios-cloud-upload",
									type: "warning"
								}
							},
							{
								name: () => this.$t("packing") + this.$t("apportion"),
								fnName: "packingCostApportion",
								type: "packingCostApportion",
								bind: {
									type: "primary"
								}
							}
						],
						methods: {
							exportOrder() {
								this.getModal("export").open(null, function() {
									this.setTitle(this.$tz("订单,导出"));
								});
							},
							packingCostApportion() {
								this.getModal("packingCostApportion").open({}, function() {
									this.setTitle(this.$t("packing") + this.$t("apportion"));
								});
							},
							analysisFun() {
								this.getModal("analysis").open({}, function() {
									this.setTitle(this.$t("analysis"));
								});
							},
							exportFun({
								searchForm
							}) {
								let data = searchForm;
								data.extract_id = this.selectAll.map(item => item.id);
								this.openLoading();
								this.handleRequestMethods(
									"exportBatchExtract",
									data,
									true,
									true
								).then(res => {
									window.open(this.$globalUrl + res.payload);
									// this.getList();
								});
							},
							exportListFun() {
								this.exportExc();
							},
							airlineMsgFun({
								searchForm
							}) {
								let data = searchForm;
								data.extract_id = this.selectAll.map(item => item.id);
								this.openLoading();
								this.handleRequestMethods("exportAirline", data, true, true).then(
									res => {
										// window.open(this.$globalUrl + res.payload.path);
										// this.getList();
                    this.$Message.success(res.data.msg)
									}
								);
							},
							flight({
								searchForm
							}) {
								let data = JSON.parse(JSON.stringify(searchForm));
								data.flight_export = 1;
								this.openLoading();
								this.handleRequestMethods("list", data, true, true).then(res => {
									window.open(this.$globalUrl + res.payload);
								});
							},
							down({
								row,
								field,
								searchForm
							}) {
								window.open(this.$globalUrl + field.url);
							},
							updateFile({
								file,
								field,
								searchForm
							}) {
								let formData = new FormData();
								formData.append("file", file);
								formData.append("type", "3");
								this.$page
									.handleRequestMethods(field.type, formData, false, true)
									.then(res => {
										if (res.payload.length) {
											this.$page.getModal("uploadMsg").open(null, function() {
												this.setTitle(
													this.$t("import") +
													(field.type == "importIncome" ?
														this.$t("income") :
														this.$t("finalCost")) +
													this.$t("info")
												);
												this.list = res.payload;
											});
										} else {
											this.$Message.success(
												this.$t("updateFile") + this.$t("success")
											);
										}
									});
								return false;
							}
						}
					}
				},
				fields: [{
						width: 35,
						type: "expand",
						fixed: "left",
						showOverflow: false,
						expandRender: (h, p) => {
							return h(expandRow, {
								props: {
									row: p.row.expand
								}
							});
						},
						fnName: "expandFun",
						methods: {
							expandFun({
								row
							}) {
								console.log(row);
								return row.id;
							}
						}
					},
					{
						type: "checkbox",
						width: 60,
						fixed: "left"
					},
					{
						name: () => this.$t("mawb"),
						key: "mawb",
						align: "left",
						minWidth: 150,
						fixed: "left",
						copy: true,
						header: {
							copy: true //头部 复制
						}
					},
					{
						name: () => this.$tz("提货,时间"),
						key: "pickup_time",
						minWidth: 110
					},
					{
						name: () => this.$t("Air Agency Time"),
						key: "shipping_agent_date",
						minWidth: 120
					},
					{
						name: () => this.$t("depart_date"),
						key: "depart_date",
						minWidth: 115
					},
					{
						name: () => this.$t("arrival_date"),
						key: "arrival_date",
						minWidth: 130
					},
					{
						name: () => this.$t("Clearance Start Time"),
						key: "clearance_start_date",
						minWidth: 120
					},
					{
						name: () => this.$tz("清关结束时间"),
						key: "clearance_date",
						minWidth: 115
					},
					{
						name: this.$t("overseasInboundTime"),
						key: "inbound_time",
						minWidth: 115
					},
					{
						name: () => this.$tz("扫描入库时间"),
						key: "arrival_warehouse",
						minWidth: 115
					},
					{
						name: () => this.$t("flight"),
						key: "flight",
						minWidth: 100
					},
					{
						name: () => this.$tz("航班,频次"),
						key: "frequency",
						minWidth: 110
					},
					{
						name: () => this.$t("number_of_bags"),
						key: "quantity",
						minWidth: 115
					},
					{
						name: () => this.$t("cod_number"),
						key: "airway_bill_total",
						minWidth: 115
					},
					{
						name: () => this.$t("not_arrival_warehouse"),
						key: "not_arrival_warehouse",
						minWidth: 80,
						render: (h, params) => {
							if (params.row.not_arrival_warehouse > 0) {
								return h("div", [
									h(
										"Button", {
											props: {
												type: "error",
												size: "small"
											},
											on: {
												click: () => {
													this.list = [];
													this.$refs["table"].getModal("showWarehouse")
													.open();
													this.$refs["table"]
														.handleRequestMethods(
															"getExtractNotWarehouse",
															params.row.id,
															false,
															true
														)
														.then(res => {
															this.list = res.payload;
														});
												}
											}
										},
										params.row.not_arrival_warehouse
									)
								]);
							} else {
								return h("div", [
									h(
										"span",

										0
									)
								]);
							}
						}
					},
					{
						name: () => this.$t("to_station"),
						key: "to_station",
						minWidth: 80
					},
					{
						name: () => this.$tz("中转,机场"),
						key: "mid_port",
						minWidth: 110
					},
					{
						name: () => this.$tz("目的机场"),
						key: "to_port",
						minWidth: 110
					},
					{
						name: () => this.$tz("是否,整板,类型"),
						key: "board_type_name",
						minWidth: 110
					},
					{
						name: () => this.$t("clearagent"),
						key: "clearance_agent",
						minWidth: 120
					},
					{
						name: () => this.$t("air_agent"),
						key: "air_agent",
						minWidth: 120
					},
					{
						name: () => this.$t("HKagency"),
						key: "hk_agent",
						minWidth: 120
					},
					{
						name: () => this.$t("warehousCustomsAgent"),
						key: "baoguan_agent",
						minWidth: 120
					},
					{
						name: () => this.$tz("文件,代理"),
						key: "file_agent",
						minWidth: 120
					},
					{
						name: () => this.$t("outbound_time"),
						key: "outbound_time",
						minWidth: 120
					},
					{
						name: () => this.$t("arrival_HK_date"),
						key: "arrival_HK_date",
						minWidth: 120
					},

					// {
					//   name: () => this.$t("charge_params"),
					//   key: "charging_weight",
					//   minWidth: 115
					// },
					{
						name: () => this.$t("charge_volume"),
						key: "volume_weight",
						minWidth: 115
					},
					{
						name: () => this.$tz("拆包,计费重"),
						key: "unpack_charge_weight",
						minWidth: 110
					},
					{
						name: () => this.$tz("B2C,计费重"),
						key: "ec_charge_weight",
						minWidth: 110
					},
					{
						name: () => this.$tz("B2B,计费重"),
						key: "dbl_charge_weight",
						minWidth: 110
					},
					{
						name: () => this.$tz("TT,计费重"),
						key: "tt_charge_weight",
						minWidth: 110
					},
					{
						name: () => this.$tz("TM,计费重"),
						key: "tm_charge_weight",
						minWidth: 110
					},
					{
						name: () => this.$tz("头程,计费重"),
						key: "top_charge_weight",
						minWidth: 110
					},
					{
						name: () => this.$tz("总计费重"),
						key: "total_charge_weight",
						minWidth: 110
					},
					{
						name: () => this.$tz("代理,计费重"),
						key: "agent_weight",
						minWidth: 110,
						bind: {
							style({
								row
							}) {
								if (row.agent_weight > row.total_charge_weight) {
									return {
										color: "red"
									};
								}
							}
						}
					},
					{
						name: () => this.$t("invoiceWeight"),
						key: "weight",
						minWidth: 115,
						bind: {
							style({
								row
							}) {
								if (row.weight > row.total_charge_weight) {
									return {
										color: "red"
									};
								}
							}
						}
					},
					{
						name: () => this.$tz("汇总,申报价值"),
						key: "values_total",
						minWidth: 110
					},
					{
						name: () => this.$tz("币种"),
						key: "currency",
						minWidth: 110
					},
					// {
					//   name: () => this.$t("gather") + this.$t("cost_t"),
					//   key: "total_cost",
					//   minWidth: 115,
					//   component: "Button",
					//   bind: {
					//     type: "primary",
					//     size: "small",
					//   },
					//   methods: {
					//     click({ row }) {
					//       this.$page.getModal("apportion").open(row, function () {
					//         this.totalAmount = row.total_cost;
					//         this.setTitle(this.$t("apportion") + "(" + row.mawb + ")");
					//       });
					//     },
					//   },
					// },
					{
						name: () => this.$t("Remarks"),
						key: "remarks",
						width: 130
					},
					{
						name: () => this.$t("createTime"),
						key: "create_time",
						minWidth: 115
					},
					{
						name: () => this.$t("createUser"),
						key: "creator_name",
						minWidth: 130
					},
					{
						type: "btns",
						width: 400,
						name: () => this.$t("operation"),
						fixed: "right",
						list: [{
								name: () => this.$t("show"),
								type: "show",
								fnName: "showFun",
								bind: {
									type: "primary"
								}
							},
							{
								name: () => this.$t("export"),
								type: "export",
								fnName: "exportFun",
								bind: {
									type: "warning"
								}
							},
              {
                name: () => this.$t("export") + 2,
                type: "export",
                fnName: "exportFun2",
                bind: {
                  type: "warning"
                }
              },
							{
								name: () => this.$t("update"),
								type: "update",
								fnName: "updateFun",
								bind: {
									type: "success"
								},
								id: 641
							},
							{
								name: () => this.$t("agentT") + this.$t("finalCost"),
								type: "openCost",
								fnName: "openCost",
								data: {
									type: 3
								},
								bind: {
									type: "warning"
								},
								id: 866
							},
							// {
							//   name: () => this.$t("apportion"),
							//   type: "apportion",
							//   fnName: "apportion",
							//   bind: {
							//     type: "error",
							//   },
							//   id: 554,
							// },
							{
								name: () => this.$tz("bayan"),
								type: "bayan",
								bind: {
									type: "primary"
								},
								fnName: "bayan",
								id: 1871
							},
							{
								name: () => this.$tz("发送,邮件"),
								type: "email",
								fnName: "email",
								bind: {
									type: "primary"
								},
								id: 1871
							},
							{
								name: () => this.$t("delete"),
								type: "delete",
								fnName: "deleteFun",
								id: 640
							}
						],

						methods: {
							bayan({
								row
							}) {
								this.getModal("bayan").open(row, function() {
									this.setTitle(this.$tz("bayan"));
									this.pageConfig.data.id = row.id;
									this.getList();
								});
							},
							apportion({
								row
							}) {
								this.getModal("apportion").open(row, function() {
									this.totalAmount = row.total_cost;
									this.setTitle(this.$t("apportion") + "(" + row.mawb + ")");
								});
							},
							email: ({
								row
							}) => {
								let table = this.$refs["table"];
								let page = this;

								table
									.handleRequestMethods(
										"info", {
											keywords: row.mawb,
											withShipment: 2
										},
										false,
										true
									)
									.then(info => {
										info = info.payload.rows[0];
										console.log(info);
										table
											.handleRequestMethods(
												"read", {
													awb: row.mawb
												},
												false,
												true
											)
											.then(res => {
												console.log(res);
												let mail = {
													awbNumber: row.mawb,
													id: row.id,
													mailBox: res.payload.mailBox,
													subject: res.payload.title,
													body: res.payload.body,
													attachment: res.payload.files.map(t => {
														t.filename = t.title;
														t.src = t.url;
														return t;
													})
												};
												page.email.fields[0].options = res.payload.mailBox.map(
													t => {
														return {
															value: t,
															label: t
														};
													}
												);
												page.tab = "info";
												table.getModal("email").open({
													mail,
													info
												}, function() {
													this.setTitle(this.$tz("发送,邮件") +
														`(${row.mawb})`);
													page.$refs["editor"][0].handleInit();
													page.$refs["package"][0].list = info.shipments;

													page.$refs["info"][0].setFormData(info);
													page.$refs["email"][0].setFormData(mail);
												});
											});
									});
							},
							async showFun({
								row
							}) {
								let res = await this.handleRequestMethods(
									"getPackages",
									row.id,
									false,
									true
								);
								// console.log(res, this.getModal("show"));
								this.getModal("show").open({
									data: res.payload.rows
								}, () => {
									this.getModal("show").setTitle(this.$t("show") + row.mawb);
									this.getModal("show").table.fields[1].name = () => {
										return (
											this.$t("order_number") +
											`(${res.payload.airway_bill_total})`
										);
									};
									this.getModal("show").table.fields[2].name = () => {
										return (
											this.$t("bagCode") +
											`(${res.payload.package_number_total})`
										);
									};
									this.getModal("show").list = res.payload.row;
								});
							},
							exportFun({
								row
							}) {
								// console.log("导出");
								this.openLoading();
								this.handleRequestMethods(
									"getExportExcel",
									row.id,
									false,
									true
								).then(res => {
									if (res.msg !== 'SUCCESS') {
                    this.$Message.error(res.msg)
                  }
									window.open(this.$globalUrl + res.payload);
								});
							},
              exportFun2({row}) {
                window.open('https://oms.vnlin.com/export/airwayBill/' + row.mawb.replace('-', '_'))
              },
							async updateFun({
								row
							}) {
								// console.log(row);
								let res = await this.handleRequestMethods(
									"getDetails",
									row.id,
									false,
									true
								);
								let list = await this.handleRequestMethods(
									"thirdParty",
									row.mawb,
									false,
									true
								);
								// console.log("res", res);
								let packing = await this.handleRequestMethods(
									"getPacking",
									row.id,
									false,
									true
								);
								res.payload.list = list.payload || [];
								this.getModal("update").open(res.payload, function() {
									this.setTitle(this.$t("update"));
									this.list = packing.payload;
								});
							},
							openCost({
								row,
								field
							}) {
								row.resType = field.data.type;
								this.getModal("openCost").open(row, function() {
									this.setTitle(this.$t("agentT") + this.$t("finalCost"));
								});
							},
							deleteFun({
								row
							}) {
								this.$Modal.confirm({
									title: this.$t("whether") +
										this.$t("confirm") +
										this.$t("delete") +
										this.$t("mawb") +
										":" +
										row.mawb +
										"?",
									onOk: () => {
										this.handleRequestMethods("del", row.id, true).then(res => {
											// this.$Message.success(res.data.msg);
											this.getList();
										});
									}
								});
							}
						}
					}
				]
			};
		}
	};
</script>
